import { FilterItem, FilterTypes, IFilterOption } from '@shared/models/filters';
import { SupplierCustomerStatus, SupplierCustomerStatusLabels } from '../enums/supplier-customer-status.enum';

export const customerStatusOptions: IFilterOption[] = [
  { id: 'customer-status-all', name: 'All', value: 'all', selected: true },
  ...Object.values(SupplierCustomerStatus).map(status => ({
    id: `customer-status-${status.toLowerCase().replace(/_/g, '-')}`,
    name: SupplierCustomerStatusLabels[status],
    value: status,
    selected: false
  }))
];

export const customerTypeOptions: IFilterOption[] = [
  { id: 'customer-type-all', name: 'All', value: 'all', selected: true },
  { id: 'customer-type-festival', name: 'Festival', value: 'Festival', selected: false },
  { id: 'customer-type-corporate', name: 'Corporate', value: 'Corporate', selected: false },
  { id: 'customer-type-private', name: 'Private', value: 'Private', selected: false }
];

export const customerAcquisitionOptions: IFilterOption[] = [
  { id: 'customer-acquisition-all', name: 'All', value: 'all', selected: true },
  { id: 'customer-acquisition-request', name: 'Request', value: 'REQUEST', selected: false },
  { id: 'customer-acquisition-inbound', name: 'Inbound', value: 'INBOUND', selected: false },
  { id: 'customer-acquisition-other', name: 'Other', value: 'OTHER', selected: false }
];

export const CUSTOMER_FILTERS: FilterItem[] = [
  {
    id: 'filter_customer_status',
    name: 'Customer Status',
    description: 'Filter by customer status',
    icon: 'ate-filter-v3',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: customerStatusOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_customer_type',
    name: 'Customer Type',
    description: 'Filter by customer type',
    icon: 'ate-filter-v3',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: customerTypeOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_customer_acquisition',
    name: 'Acquisition Type',
    description: 'Filter by acquisition type',
    icon: 'ate-filter-v3',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: customerAcquisitionOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_customer_search',
    name: 'Search',
    type: FilterTypes.SEARCH,
    active: false,
    options: null,
    options_selected: 0,
    value: ''
  }
];
